<div *ngIf="selectedOptionsCount > 0" class="filter-options-action-header">
  <span class="selected-options-count"
    ><b>{{ selectedOptionsCount }}</b> selected</span
  >
  <a mat-flat-button class="clear-all link-button" (click)="clearAllOptions()"
    >Clear all</a
  >
</div>
<div class="filter-options-container">
  <div
    class="option"
    *ngFor="let option of options; let last = last"
    [ngClass]="{ 'mb-16': !last }">
    <mat-checkbox
      [value]="option.value"
      [(ngModel)]="option.isSelected"
      (change)="handleCheckedFilterOption(option)"
      [checked]="option.isSelected"
      >{{ option.label }}</mat-checkbox
    >
  </div>
</div>
